import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const TextBragBar = dynamic(() => import('./TextBragBar'));

export const defaultOptions = {
	items: [
		{ title: '12+ Years', subtitle: 'Pursuing Justice' },
		{ title: '100% Free', subtitle: 'Case Evaluation' },
	],
	backgroundColor: '#2C3A5A',
} as const;

Builder.registerComponent(TextBragBar, {
	name: 'TextBragBar',
	inputs: [
		{
			name: 'items',
			friendlyName: 'Items',
			type: 'list',
			defaultValue: [...defaultOptions.items],
			helperText: 'Maximum 3 items. A 4th one is removed automatically.',
			subFields: [
				{
					name: 'title',
					friendlyName: 'Title',
					type: 'string',
					required: true,
					defaultValue: 'Placeholder Title',
				},
				{
					name: 'subtitle',
					friendlyName: 'Subtitle',
					type: 'string',
					defaultValue: 'Placeholder Subtitle',
				},
			],
			onChange: function (options) {
				const items = options.get('items');
				if (items?.length > 3) {
					options.set('items', items.slice(0, 3));
				}
			},
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: defaultOptions.backgroundColor,
		},
	],
	image: getIconUrl(Icon.BRAGBAR),
});
